// The orchestrator writes agent-facing copy for these codes only; the message on any
// other error can carry internal system detail that agents can't act on.
const PRECO_FORMATTED_ERROR_CODES = [
  'PRECO_INVALID_PAYMENT_PLAN_TOTAL',
  'PRECO_INVALID_PAYMENT_PLAN_DATE',
  'PRECO_INVALID_PAYMENT_PLAN_AMOUNT',
];

export const getPrecoErrorReason = (error) =>
  (error?.errors ?? []).find(
    ({ extensions, message }) =>
      PRECO_FORMATTED_ERROR_CODES.includes(extensions?.errorCode) && message,
  )?.message ?? null;

export const getPrecoPlanCreationMessage = (error, { isEnrollingOffer }) => {
  const prefix = isEnrollingOffer
    ? 'Failed to create payment plan with enrollment'
    : 'Failed to create payment plan';
  const reason = getPrecoErrorReason(error);

  return `${prefix}${reason ? `: ${reason.replace(/\.$/, '')}` : ''}. Please try again.`;
};
